import { render, staticRenderFns } from "./MessageLabelAdduser.vue?vue&type=template&id=5fa98919&scoped=true&"
import script from "./MessageLabelAdduser.vue?vue&type=script&lang=js&"
export * from "./MessageLabelAdduser.vue?vue&type=script&lang=js&"
import style0 from "./MessageLabelAdduser.vue?vue&type=style&index=0&id=5fa98919&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa98919",
  null
  
)

export default component.exports